var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.getLabel(_vm.config, _vm.lang))+" "),(_vm.isActive)?_c('qrcode-stream',{on:{"decode":_vm.onDecode}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }